import { Dispatch } from 'redux'

import { getAllTagOptions } from 'redux/api/TagOptions'

import * as actions from './actions'

export function tryGetAllTagOptions(dispatch: Dispatch) {
  getAllTagOptions()
    .then((response) => {
      dispatch(actions.getAllSuccess(response.data))
    })
    .catch(() => {})
}
